import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import format from "date-fns/format";

const End = ({ message, onTime,language }) => {
  const [endDate, setEndDate] = useState(Date())
  // console.log( message, onTime)


  useEffect(() => {
    if (onTime) {
      setEndDate(format(new Date(onTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"))
    }
  }, [onTime])

  // const Start = format(onTime, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
  return (
    <Container>
      <Title>
        {message ? message :
          language==1?
          "Il semble que nous ayons déjà reçu votre réponse à l'enquête"
          :
          'Looks like we have already recieved your survey response'
        }
      </Title>

      <SubTitle>  {endDate ? language==1?
      `Reçu le ${format(
          new Date(endDate.toLocaleString()),
          "MMM do h:mm a"
        )}`
      :`Received on ${format(
          new Date(endDate.toLocaleString()),
          "EEEE, MMM do h:mm a"
        )}` : ''}
        
      </SubTitle>


    </Container>

  )
}


export default End


const Title = styled.div`
	font-size: 30px;
  font-weight: bold;
  font-family: 'Barlow', sans-serif;
  margin-bottom:20px;
  color:black;
   line-height:1;
   max-width:654px;

   @media only screen and (min-width:992px){
   font-size: 30px;
   margin-bottom:50px;
  }
`
const SubTitle = styled.div`
	font-size: 18px;
	line-height: 1.17;
  color: black;
  font-family: 'Barlow', sans-serif;
  margin-bottom:20px;
  max-width:654px;

   @media only screen and (min-width:992px){
   font-size: 72px;
   margin-bottom:50px;
   font-size: 24px;
  }
`

// const Next = styled.div`
// 	width: 170px;
//   height: 47px;
//    border-radius: 5px;
//   background-color: white;
//   color: #6a00ff;
//    font-size: 16px;
//   font-weight: bold;
//   font-family: 'Red Hat Display', sans-serif;
//   display:flex;
//   align-items:center;
//   justify-content:center;
//   cursor:pointer;
// `

const Container = styled.div`
  position:absolute;
  top:15%;
  padding:20px;

  @media only screen and (min-width:992px){
    left: 25%;
  top: 25%;
  }
`